// File: client/src/components/layout/Header.jsx
// Header for FemaleUTI — sticky with backdrop blur, pink→purple gradient pill logo,
// gradient CTA button. Matches the playful-gradient design language used on Home
// and the frosted-glass booking page.

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHeart } from 'react-icons/fa';
import BRAND_CONFIG from '../../config/brand';

const Header = () => {
  const location = useLocation();
  const isBookingPage = location.pathname.startsWith('/book-consultation');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full transition-all duration-200 ${
        scrolled
          ? 'bg-white/80 backdrop-blur-lg border-b border-primary-100 shadow-sm'
          : 'bg-white/60 backdrop-blur border-b border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" aria-label={`${BRAND_CONFIG.name} home`}>
          <span className="w-10 h-10 rounded-2xl bg-gradient-to-br from-[#FF5CA8] to-[#8B2ABE] flex items-center justify-center shadow-lg shadow-pink-300/50 group-hover:shadow-pink-400/60 transition-shadow">
            <FaHeart className="text-white w-3.5 h-3.5" />
          </span>
          <span className="text-xl font-extrabold tracking-tight text-ink">
            {BRAND_CONFIG.name}
          </span>
        </Link>

        {!isBookingPage && (
          <Link
            to="/book-consultation"
            className="btn-gradient font-bold px-5 py-2.5 rounded-full text-sm inline-flex items-center gap-2"
          >
            Get Rx — {BRAND_CONFIG.services.consultationPrice}
            <span aria-hidden="true">✨</span>
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
